// Größe der Oberfläche wie in der Triage-App (dashboard/groesse.py): die Seite wächst mit dem Fenster,
// min(Breite/1440, Höhe/900), nie unter 1 und höchstens 2,4, mal der eigenen Größe (70–160 %).
// Handys und Touch-Geräte (Pixel Fold außen wie innen) bleiben bei 1; dort regelt das Layout selbst.
// Gezoomt wird #app; vh/vw im CSS deshalb nur über var(--vh)/var(--vw), die den Zoom wieder herausrechnen.
import { loadPref, savePref } from './prefs';

const BASE_W = 1440, BASE_H = 900, MOST = 2.4, MOBILE_BELOW = 900;
export const SIZE = { min: 70, max: 160, step: 5, standard: 100 } as const;

export function autoZoom(w: number, h: number, coarse: boolean): number {
  if (w < MOBILE_BELOW || coarse) return 1;
  return Math.max(1, Math.min(w / BASE_W, h / BASE_H, MOST));
}

/** Zoom samt eigener Größe, auf 0,05 gerundet, damit Rundungen nicht flackern */
export function zoomFor(w: number, h: number, coarse: boolean, sizePct: number): number {
  return Math.round(autoZoom(w, h, coarse) * (sizePct / 100) * 20) / 20;
}

/** Prozent in Stufen zu 5, begrenzt; Unlesbares wird 100 */
export function checkSize(v: unknown): number {
  const n = Number(v);
  if (!Number.isFinite(n)) return SIZE.standard;
  return Math.max(SIZE.min, Math.min(SIZE.max, Math.round(n / SIZE.step) * SIZE.step));
}

let size: number = SIZE.standard;
let current = 0;

function apply() {
  const z = zoomFor(innerWidth, innerHeight, matchMedia('(pointer: coarse)').matches, size);
  if (z === current) return;
  current = z;
  document.documentElement.style.setProperty('--ui-zoom', String(z));
  // chessground misst Bretter bei resize neu
  dispatchEvent(new Event('resize'));
}

export const uiZoom = () => current || 1;
export const uiSize = () => size;

export function setSize(pct: number) {
  size = checkSize(pct);
  savePref('ui.size', size);
  apply();
}

export function initZoom() {
  size = checkSize(loadPref('ui.size', SIZE.standard));
  apply();
  addEventListener('resize', apply);
}
